/** Matches an Armaf-type code: a single type letter followed by "ARF" (e.g. QARF…, MARF…). */
const ARMAF_TYPED = /^[A-Z]ARF/

/**
 * Formats an Armaf article code for display when the user is AVP-only.
 *
 * Rule: strip the leading type letter ONLY when the code is an Armaf-typed code —
 * a single type letter followed by "ARF" (QARF…/MARF…/XARF… → ARF…). Codes that
 * are already "ARF…" (no type letter) and any non-Armaf code (materials/components
 * like "TAPA500" or numeric codes) are returned unchanged, so the pattern guard
 * never corrupts a code that does not follow the Armaf convention.
 * For non-AVP-only users the code is returned unchanged.
 *
 * The code is trimmed first: some references are created with a leading/trailing
 * space, and without trimming the leading space would break the pattern match
 * (e.g. " MARF123" would not match and would render "MARF123" instead of "ARF123").
 */
export function fmtArticulo(code: string | undefined | null, isAvpOnly: boolean): string {
  if (!code) return ''
  const c = code.trim()
  if (!isAvpOnly) return c
  if (ARMAF_TYPED.test(c)) return c.slice(1)
  return c
}
